import {NgModule} from '@angular/core';
import {MatFormFieldModule} from "@angular/material/form-field";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {AutocompleteInputComponent} from "./autocomplete-input.component";
import {MatOptionModule} from "@angular/material/core";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatInputModule} from "@angular/material/input";


@NgModule({
    declarations: [
        AutocompleteInputComponent,
    ],
    exports: [
        AutocompleteInputComponent,
    ],
    imports: [
        ReactiveFormsModule,
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatOptionModule,
        MatAutocompleteModule,
        MatInputModule
    ]
})
export class AutocompleteInputModule {}
